import styles from "./Card.module.css";

function Card({ label, value }) {
	return (
		<div className={styles.card}>
			<div className={styles.label}>{label}:</div>
			<div className={styles.value}>{value}</div>
		</div>
	);
}

export default Card;
